export enum Theme {
  LIGHT = 'light',
  DARK = 'dark',
}

export interface BrandTokens {
  primary: string
  // Optional secondary brand accent. Clientportal sets it from portal brandColor2;
  // community/preset tokens omit it and fall back to the theme.css `--cp-secondary-*`
  // defaults. Not part of the completeness gate so existing 8-key literals stay valid.
  secondary?: string
  tertiary: string
  background: string
  surface: string
  error: string
  fontColor: string
  sidebar: string
  border: string
  // Optional SDUI / location-theme extras. Existing 8-key callers stay valid.
  success?: string
  warning?: string
  neutral?: string
  info?: string
  primaryContent?: string
  secondaryContent?: string
  tertiaryContent?: string
  neutralContent?: string
  infoContent?: string
  successContent?: string
  warningContent?: string
  errorContent?: string
  sidebarContent?: string
}

/** Light + dark token sets used only by SDUI `setBrandTokenModes`. */
export interface BrandTokenModes {
  readonly light: BrandTokens
  readonly dark: BrandTokens
}
